import Mood1 from './icons/Valence1.svg';
import Mood2 from './icons/Valence2.svg';
import Mood3 from './icons/Valence3.svg';
import Mood4 from './icons/Valence4.svg';
import Mood5 from './icons/Valence5.svg';
import Mood6 from './icons/Valence6.svg';
import Awake1 from './icons/Awake1.svg';
import Awake2 from './icons/Awake2.svg';
import Awake3 from './icons/Awake3.svg';
import Awake4 from './icons/Awake4.svg';
import Awake5 from './icons/Awake5.svg';
import Awake6 from './icons/Awake6.svg';
import Stress1 from './icons/Stress1.svg';
import Stress2 from './icons/Stress2.svg';
import Stress3 from './icons/Stress3.svg';
import Stress4 from './icons/Stress4.svg';
import Stress5 from './icons/Stress5.svg';
import Stress6 from './icons/Stress6.svg';
import Satisfaction1 from './icons/Satisfaction1.svg';
import Satisfaction2 from './icons/Satisfaction2.svg';
import Satisfaction3 from './icons/Satisfaction3.svg';
import Satisfaction4 from './icons/Satisfaction4.svg';
import Satisfaction5 from './icons/Satisfaction5.svg';
import Satisfaction6 from './icons/Satisfaction6.svg';

export const Survey = {
    questions: [
        { title: 'stress', question: 'In terms of your current stress level, do you feel more confident or overwhelmed?' },
        { title: 'mood', question: 'How good or bad do you feel?' },
        { title: 'tiredness', question: 'How tired or awake do you feel?' },
        { title: 'satisfaction', question: 'How satisfied are you with how life is going overall?' },
    ],
    values: [
        [
            { value: 1, icon: Stress6, category: 'Stress' },
            { value: 2, icon: Stress5, category: 'Stress' },
            { value: 3, icon: Stress4, category: 'Stress' },
            { value: 4, icon: Stress3, category: 'Stress' },
            { value: 5, icon: Stress2, category: 'Stress' },
            { value: 6, icon: Stress1, category: 'Stress' },
        ],
        [
            { value: 1, icon: Mood1, category: 'Mood' },
            { value: 2, icon: Mood2, category: 'Mood' },
            { value: 3, icon: Mood3, category: 'Mood' },
            { value: 4, icon: Mood4, category: 'Mood' },
            { value: 5, icon: Mood5, category: 'Mood' },
            { value: 6, icon: Mood6, category: 'Mood' },
        ],
        [
            { value: 1, icon: Awake1, category: 'Awake' },
            { value: 2, icon: Awake2, category: 'Awake' },
            { value: 3, icon: Awake3, category: 'Awake' },
            { value: 4, icon: Awake4, category: 'Awake' },
            { value: 5, icon: Awake5, category: 'Awake' },
            { value: 6, icon: Awake6, category: 'Awake' },
        ],
        [
            { value: 1, icon: Satisfaction1, category: 'Satisfaction' },
            { value: 2, icon: Satisfaction2, category: 'Satisfaction' },
            { value: 3, icon: Satisfaction3, category: 'Satisfaction' },
            { value: 4, icon: Satisfaction4, category: 'Satisfaction' },
            { value: 5, icon: Satisfaction5, category: 'Satisfaction' },
            { value: 6, icon: Satisfaction6, category: 'Satisfaction' },
        ],
    ],
};
